import { createContext, useContext } from "react";
import type { Session } from "../lib/auth-client";

export interface AuthContextValue {
  session: Session;
  loading: boolean;
  sessionExpired: boolean;
  signInWithLine: () => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}
